/**
 * ss-brands-page.js — search filter + letter jump smooth scroll
 */
(function () {
  function init(root) {
    if (!root || root.dataset.ssBrandsReady === '1') return;
    root.dataset.ssBrandsReady = '1';

    var search = root.querySelector('[data-ss-brands-search]');
    var empty = root.querySelector('[data-ss-brands-empty]');
    var clearBtn = root.querySelector('[data-ss-brands-clear]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.ss-brands__item'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.ss-brands__group'));
    var jumpLinks = Array.prototype.slice.call(root.querySelectorAll('[data-ss-brands-jump] .ss-brands__jump-link'));

    function updateJumpDisabled() {
      jumpLinks.forEach(function (link) {
        var letter = link.getAttribute('data-letter');
        var group = root.querySelector('[data-letter-group="' + letter + '"]');
        var disabled = !group || group.classList.contains('is-hidden');
        link.classList.toggle('is-disabled', disabled);
      });
    }

    function applyFilter(query) {
      var q = (query || '').trim().toLowerCase();
      var visibleCount = 0;

      items.forEach(function (item) {
        var name = (item.getAttribute('data-brand-name') || '').toLowerCase();
        var match = !q || name.indexOf(q) !== -1;
        item.classList.toggle('is-hidden', !match);
        if (match) visibleCount += 1;
      });

      groups.forEach(function (group) {
        var visibleItems = group.querySelectorAll('.ss-brands__item:not(.is-hidden)');
        group.classList.toggle('is-hidden', visibleItems.length === 0);
      });

      if (empty) {
        if (visibleCount === 0 && items.length > 0) {
          empty.removeAttribute('hidden');
        } else {
          empty.setAttribute('hidden', '');
        }
      }

      updateJumpDisabled();
    }

    if (search) {
      search.addEventListener('input', function () {
        applyFilter(search.value);
      });
    }

    if (clearBtn && search) {
      clearBtn.addEventListener('click', function () {
        search.value = '';
        applyFilter('');
        search.focus();
      });
    }

    jumpLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (link.classList.contains('is-disabled')) {
          e.preventDefault();
          return;
        }
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = root.querySelector(href);
        if (!target) return;
        e.preventDefault();
        jumpLinks.forEach(function (l) {
          l.classList.remove('is-active');
        });
        link.classList.add('is-active');
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) {
          history.replaceState(null, '', href);
        }
      });
    });

    updateJumpDisabled();
  }

  function boot() {
    document.querySelectorAll('[data-ss-brands]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector('[data-ss-brands]')
      : null;
    if (section) init(section);
  });
})();
